export const setOwnerOptions = ({ user, columns, data }) => {
  const ownerAccessor = columns.findIndex((c) => c.accessor === 'owner');

  data.forEach((d) => {
    const ownerIndex = columns[ownerAccessor].options.findIndex(
      (x) => x.id === d.id,
    );

    const role = d.role;
    const label = `${d[role].firstName} ${d[role].lastName}`;

    if (ownerIndex === -1)
      columns[ownerAccessor].options.push({
        id: d.id,
        value: d.id,
        label,
        email: d.email,
        selected: user.email === d.email || d.id === 'blank',
      });
  });

  return columns;
};
